import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "eoi-page" }
const _hoisted_2 = {
  key: 1,
  class: "success-screen"
}
const _hoisted_3 = { class: "success-icon-wrap" }
const _hoisted_4 = { class: "success-actions" }
const _hoisted_5 = {
  key: 2,
  class: "page-content"
}
const _hoisted_6 = { class: "eoi-grid" }
const _hoisted_7 = { class: "form-col" }
const _hoisted_8 = { class: "form-block" }
const _hoisted_9 = { class: "field" }
const _hoisted_10 = {
  key: 0,
  class: "field-error"
}
const _hoisted_11 = { class: "field" }
const _hoisted_12 = {
  key: 0,
  class: "field-error"
}
const _hoisted_13 = { class: "field" }
const _hoisted_14 = {
  key: 0,
  class: "field-error"
}
const _hoisted_15 = { class: "form-block" }
const _hoisted_16 = { class: "field" }
const _hoisted_17 = { class: "radio-group" }
const _hoisted_18 = { class: "radio-option" }
const _hoisted_19 = { class: "radio-option" }
const _hoisted_20 = { class: "radio-option" }
const _hoisted_21 = { class: "radio-option" }
const _hoisted_22 = { class: "field" }
const _hoisted_23 = { class: "radio-group" }
const _hoisted_24 = { class: "radio-option" }
const _hoisted_25 = { class: "radio-option" }
const _hoisted_26 = { class: "radio-option" }
const _hoisted_27 = { class: "radio-option" }
const _hoisted_28 = { class: "field" }
const _hoisted_29 = { class: "agreement-group" }
const _hoisted_30 = { class: "agreement-option" }
const _hoisted_31 = { class: "agreement-option" }
const _hoisted_32 = {
  key: 0,
  class: "field-error"
}
const _hoisted_33 = { class: "summary-col" }
const _hoisted_34 = { class: "summary-card" }
const _hoisted_35 = ["src", "alt"]
const _hoisted_36 = {
  key: 1,
  class: "card-image-placeholder"
}
const _hoisted_37 = { class: "card-body" }
const _hoisted_38 = { class: "summary-details" }
const _hoisted_39 = { class: "detail-stacked" }
const _hoisted_40 = { class: "detail-name" }
const _hoisted_41 = {
  key: 0,
  class: "detail-stacked"
}
const _hoisted_42 = { class: "detail-bold" }
const _hoisted_43 = { class: "detail-stacked" }
const _hoisted_44 = {
  key: 0,
  class: "detail-bold"
}
const _hoisted_45 = {
  key: 1,
  class: "detail-italic"
}
const _hoisted_46 = {
  key: 1,
  class: "detail-stacked"
}
const _hoisted_47 = { class: "detail-bold" }
const _hoisted_48 = {
  key: 0,
  class: "specs-row"
}
const _hoisted_49 = {
  key: 0,
  class: "spec-item"
}
const _hoisted_50 = {
  key: 1,
  class: "spec-item"
}
const _hoisted_51 = {
  key: 2,
  class: "spec-item"
}
const _hoisted_52 = {
  key: 3,
  class: "spec-item"
}
const _hoisted_53 = { class: "upgrades-section" }
const _hoisted_54 = { class: "upgrade-name" }
const _hoisted_55 = { class: "upgrade-price" }
const _hoisted_56 = { class: "price-row" }
const _hoisted_57 = { class: "price-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!$setup.isEmbedded)
      ? (_openBlock(), _createBlock($setup["CustomerNavbar"], {
          key: 0,
          logoUrl: $setup.projectPage?.residentialContent?.logoImageUrl,
          brandText: $setup.projectPage?.residentialContent?.brandText || 'Vista Living',
          onBack: $setup.goBack
        }, null, 8, ["logoUrl", "brandText"]))
      : _createCommentVNode("", true),
    ($setup.submitted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode($setup["CheckCircle2"], { size: 56 })
          ]),
          _cache[15] || (_cache[15] = _createElementVNode("h1", { class: "success-heading" }, "Thank You!", -1)),
          _cache[16] || (_cache[16] = _createElementVNode("p", { class: "success-message" }, "Your Expression of Interest has been received. Our team will be in touch with you shortly to discuss next steps.", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "success-btn-primary",
              onClick: $setup.browseMoreDesigns
            }, "Browse More Designs"),
            _createElementVNode("button", {
              class: "success-btn-outline",
              onClick: $setup.exploreMap
            }, [
              _createVNode($setup["Map"], { size: 18 }),
              _cache[14] || (_cache[14] = _createElementVNode("span", null, "Explore the Map", -1))
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          ($setup.isEmbedded)
            ? (_openBlock(), _createBlock($setup["PageBackButton"], {
                key: 0,
                style: {"padding":"0 0 1rem"}
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[35] || (_cache[35] = _createElementVNode("h2", { class: "form-title" }, "Submit Your Expression of Interest", -1)),
              _createElementVNode("div", _hoisted_8, [
                _cache[20] || (_cache[20] = _createElementVNode("h3", { class: "block-title" }, "Your Details", -1)),
                _createElementVNode("div", _hoisted_9, [
                  _cache[17] || (_cache[17] = _createElementVNode("label", { class: "field-label" }, "Full Name *", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(["field-input", { 'field-input--error': $setup.errors.fullName }]),
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.formData.fullName) = $event))
                  }, null, 2), [
                    [_vModelText, $setup.formData.fullName]
                  ]),
                  ($setup.errors.fullName)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString($setup.errors.fullName), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[18] || (_cache[18] = _createElementVNode("label", { class: "field-label" }, "Email Address *", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(["field-input", { 'field-input--error': $setup.errors.email }]),
                    type: "email",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.formData.email) = $event))
                  }, null, 2), [
                    [_vModelText, $setup.formData.email]
                  ]),
                  ($setup.errors.email)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString($setup.errors.email), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[19] || (_cache[19] = _createElementVNode("label", { class: "field-label" }, "Phone Number *", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(["field-input", { 'field-input--error': $setup.errors.phone }]),
                    type: "tel",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.formData.phone) = $event))
                  }, null, 2), [
                    [_vModelText, $setup.formData.phone]
                  ]),
                  ($setup.errors.phone)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString($setup.errors.phone), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[34] || (_cache[34] = _createElementVNode("h3", { class: "block-title" }, "Your Preferences", -1)),
                _createElementVNode("div", _hoisted_16, [
                  _cache[25] || (_cache[25] = _createElementVNode("label", { class: "field-label" }, "Preferred Timeframe", -1)),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", _hoisted_18, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.formData.timeframe) = $event)),
                        value: "immediately"
                      }, null, 512), [
                        [_vModelRadio, $setup.formData.timeframe]
                      ]),
                      _cache[21] || (_cache[21] = _createElementVNode("span", null, "Immediately", -1))
                    ]),
                    _createElementVNode("label", _hoisted_19, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.formData.timeframe) = $event)),
                        value: "3-6"
                      }, null, 512), [
                        [_vModelRadio, $setup.formData.timeframe]
                      ]),
                      _cache[22] || (_cache[22] = _createElementVNode("span", null, "3-6 months", -1))
                    ]),
                    _createElementVNode("label", _hoisted_20, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.formData.timeframe) = $event)),
                        value: "6-12"
                      }, null, 512), [
                        [_vModelRadio, $setup.formData.timeframe]
                      ]),
                      _cache[23] || (_cache[23] = _createElementVNode("span", null, "6-12 months", -1))
                    ]),
                    _createElementVNode("label", _hoisted_21, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.formData.timeframe) = $event)),
                        value: "12+"
                      }, null, 512), [
                        [_vModelRadio, $setup.formData.timeframe]
                      ]),
                      _cache[24] || (_cache[24] = _createElementVNode("span", null, "12+ months", -1))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _cache[30] || (_cache[30] = _createElementVNode("label", { class: "field-label" }, "Current Living Situation", -1)),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("label", _hoisted_24, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.formData.currentLiving) = $event)),
                        value: "own-home"
                      }, null, 512), [
                        [_vModelRadio, $setup.formData.currentLiving]
                      ]),
                      _cache[26] || (_cache[26] = _createElementVNode("span", null, "Own a home (selling)", -1))
                    ]),
                    _createElementVNode("label", _hoisted_25, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.formData.currentLiving) = $event)),
                        value: "renting"
                      }, null, 512), [
                        [_vModelRadio, $setup.formData.currentLiving]
                      ]),
                      _cache[27] || (_cache[27] = _createElementVNode("span", null, "Renting", -1))
                    ]),
                    _createElementVNode("label", _hoisted_26, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.formData.currentLiving) = $event)),
                        value: "downsizing"
                      }, null, 512), [
                        [_vModelRadio, $setup.formData.currentLiving]
                      ]),
                      _cache[28] || (_cache[28] = _createElementVNode("span", null, "Downsizing", -1))
                    ]),
                    _createElementVNode("label", _hoisted_27, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.formData.currentLiving) = $event)),
                        value: "other"
                      }, null, 512), [
                        [_vModelRadio, $setup.formData.currentLiving]
                      ]),
                      _cache[29] || (_cache[29] = _createElementVNode("span", null, "Other", -1))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _cache[31] || (_cache[31] = _createElementVNode("label", { class: "field-label" }, "Additional Notes", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    class: "field-input field-textarea",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.formData.notes) = $event)),
                    placeholder: "Any questions or specific requirements..."
                  }, null, 512), [
                    [_vModelText, $setup.formData.notes]
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("label", _hoisted_30, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.formData.agreeToContact) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, $setup.formData.agreeToContact]
                    ]),
                    _cache[32] || (_cache[32] = _createElementVNode("span", null, "I agree to be contacted by the sales team about my enquiry", -1))
                  ]),
                  _createElementVNode("label", _hoisted_31, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.formData.agreeToPrivacy) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, $setup.formData.agreeToPrivacy]
                    ]),
                    _cache[33] || (_cache[33] = _createElementVNode("span", null, "I have read and agree to the privacy policy", -1))
                  ]),
                  ($setup.errors.agreements)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString($setup.errors.agreements), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("button", {
                class: "submit-btn",
                onClick: $setup.handleSubmit
              }, "Submit Expression of Interest")
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                ($setup.houseImage)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "card-image",
                      src: $setup.houseImage,
                      alt: $setup.house?.name || 'House'
                    }, null, 8, _hoisted_35))
                  : (_openBlock(), _createElementBlock("div", _hoisted_36, "🏠")),
                _cache[45] || (_cache[45] = _createElementVNode("div", { class: "card-header" }, [
                  _createElementVNode("span", { class: "card-title" }, "Your Selection Summary")
                ], -1)),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _cache[36] || (_cache[36] = _createElementVNode("p", { class: "detail-muted" }, "Home Design", -1)),
                      _createElementVNode("p", _hoisted_40, _toDisplayString($setup.house?.name || "-"), 1)
                    ]),
                    ($setup.selectedFacade)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _cache[37] || (_cache[37] = _createElementVNode("p", { class: "detail-muted" }, "Facade", -1)),
                          _createElementVNode("p", _hoisted_42, _toDisplayString($setup.selectedFacade.name), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_43, [
                      _cache[38] || (_cache[38] = _createElementVNode("p", { class: "detail-muted" }, "Interior Colour Scheme", -1)),
                      ($setup.selectedColorScheme)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_44, _toDisplayString($setup.selectedColorScheme.name), 1))
                        : (_openBlock(), _createElementBlock("p", _hoisted_45, "Not selected"))
                    ]),
                    ($setup.selectedLot)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _cache[39] || (_cache[39] = _createElementVNode("p", { class: "detail-muted" }, "Lot Number", -1)),
                          _createElementVNode("p", _hoisted_47, _toDisplayString($setup.selectedLot.title), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  ($setup.hasSpecs)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                        ($setup.house?.bedroom)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                              _createVNode($setup["Bed"], { size: 18 }),
                              _createElementVNode("span", null, _toDisplayString($setup.house.bedroom), 1)
                            ]))
                          : _createCommentVNode("", true),
                        ($setup.bathroomCount)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                              _createVNode($setup["Bath"], { size: 18 }),
                              _createElementVNode("span", null, _toDisplayString($setup.bathroomCount), 1)
                            ]))
                          : _createCommentVNode("", true),
                        ($setup.house?.garage)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                              _createVNode($setup["Car"], { size: 18 }),
                              _createElementVNode("span", null, _toDisplayString($setup.house.garage), 1)
                            ]))
                          : _createCommentVNode("", true),
                        ($setup.house?.area)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                              _createVNode($setup["Maximize2"], { size: 18 }),
                              _createElementVNode("span", null, _toDisplayString($setup.house.area) + "m²", 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.selectedUpgrades.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _cache[41] || (_cache[41] = _createElementVNode("div", { class: "card-divider" }, null, -1)),
                        _createElementVNode("div", _hoisted_53, [
                          _cache[40] || (_cache[40] = _createElementVNode("p", { class: "detail-muted" }, "Optional Upgrades", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectedUpgrades, (upgrade) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "upgrade-row",
                              key: upgrade._id
                            }, [
                              _createElementVNode("span", _hoisted_54, _toDisplayString(upgrade.name), 1),
                              _createElementVNode("span", _hoisted_55, "+" + _toDisplayString($setup.formatPrice(upgrade.price || 0)), 1)
                            ]))
                          }), 128))
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  _cache[43] || (_cache[43] = _createElementVNode("div", { class: "card-divider" }, null, -1)),
                  _createElementVNode("div", _hoisted_56, [
                    _cache[42] || (_cache[42] = _createElementVNode("span", { class: "price-label" }, "Estimated Price", -1)),
                    _createElementVNode("span", _hoisted_57, _toDisplayString($setup.displayPrice), 1)
                  ]),
                  _cache[44] || (_cache[44] = _createElementVNode("p", { class: "price-note" }, "Price is indicative and subject to change", -1))
                ])
              ])
            ])
          ])
        ]))
  ]))
}